<template>
  <div class="component-bridge-upload">
    <van-uploader
      ref="vanUploadFileRef"
      v-model="picLink"
      :max-count="maxCount"
      :max-size="isOverSize"
      :after-read="handleAfterRead"
      :readonly="isInApp"
      @click-upload="handleUploadByBridge"
      @oversize="handleOverSize"
      @delete="handleDeleteFile"
    >
      <slot />
    </van-uploader>
    <van-action-sheet v-model="showUploadSheet" :actions="actions" cancel-text="取消" @select="handleSelect" />
  </div>
</template>

<script>
import CompressImg from '@/utils/CompressImg'
import BlobUtil from '@/utils/CompressImg/blobutil'
import bridge, { isInApp, CAMERA, PHOTO, PDF } from '@/utils/bridge'
import * as rnr from '@/api/rnr'
import * as markup from '@/api/markup'
import { Toast } from 'vant'

export default {
  name: 'BridgeUploadSelect',
  props: {
    maxCount: {
      type: Number,
      default: 5
    },
    maxSize: {
      type: Number,
      default: 500 * 1024
    },
    value: {
      type: Array,
      default: () => ([])
    },
    security: {
      type: Boolean,
      default: false
    },
    compress: {
      type: Object,
      default: null
    },
    customer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showUploadSheet: false,
      picLink: [],
      actions: [
        { name: '拍照', value: CAMERA },
        { name: '从相册选择', value: PHOTO }
      ],
      isInApp,
      appVersion: '1.0'
    }
  },
  // activated() {},
  mounted() {
    if (isInApp) {
      bridge.getAppVersion((version = '') => {
        this.appVersion = version
        if (version === '2.0') {
          this.actions = [
            { name: '拍照', value: CAMERA },
            { name: '从相册选择', value: PHOTO },
            { name: '上传PDF', value: PDF }
          ]
        }
      })
      // 获取文件
      const fileInput = this.$refs.vanUploadFileRef.$el.querySelector('input[type=file]')
      // 如果获取到input属性
      if (fileInput) {
        fileInput.disabled = 'disabled'
      }
    }
  },
  methods: {
    /**
     * 更新文件
     * @param file 需要更新的文件
     * @param index 需要更新的索引
     */
    updateFile(file, index = 0) {
      // 保存当前文件
      this.$set(this.picLink, index, file)
      // 开始上传文件
      this.handleAfterRead(file)
    },

    /**
     * 如果通过bridge上传
     */
    handleUploadByBridge() {
      if (isInApp) {
        this.showUploadSheet = true
      }
    },

    /**
     * 删除文件
     * @param index 当前文件索引
     */
    handleDeleteFile(files, { index }) {
      // 将文件id保存在照片中
      const newValue = [...this.value]
      // 从数组中删除此项
      newValue.splice(index, 1)
      // 开始双向绑定
      this.$emit('input', newValue)
      // 触发change方法
      this.$emit('change', newValue)
    },

    /**
     * 读取文件后，开始上传文件
     * @param file 当前选中的文件
     */
    async handleAfterRead(file) {
      // ================图片不压缩=================
      // 修改前，压缩上传
      // // 等待上传的图片
      // let uploadFile = file.file
      // // 如果当前需要压缩
      // if (this.compress) {
      //   try {
      //     uploadFile = await this.compressImage(file.file, this.compress)
      //   } catch (error) {
      //     console.log('压缩图片报错：', file.file)
      //     return
      //   }
      // }
      // 修改后，不压缩
      const uploadFile = file.file
      // 展示上传中状态
      file.status = 'uploading'
      file.message = '上传中...'
      try {
        // 文件可访问路径和文件的uuid
        const { uuid } = await (this.security ? (this.customer ? markup : rnr).cuscImageUpload : (this.customer ? markup : rnr).fileUpload)({ file: uploadFile })
        // 将文件id保存在照片中
        const newValue = [
          ...this.value,
          uuid
        ]
        // 清空加载的提示信息
        file.status = ''
        file.message = ''
        // 开始双向绑定
        this.$emit('input', newValue)
        // 触发change方法
        this.$emit('change', newValue)
      } catch (error) {
        // 如果上传失败
        file.status = 'failed'
        file.message = '上传失败'
      }
      console.log('picLink: ', this.picLink)
    },

    /**
     * 压缩图片
     * @param file 当前等待上传的文件
     * @param options 压缩选项
     */
    compressImage(file, options) {
      return new Promise((resolve, reject) => {
        CompressImg(file, {
          size: 1000,
          quality: 90,
          ...options,
          cb: (dataURL) => {
            const abData = BlobUtil.base64ToArrayBuffer(dataURL)
            if (abData.length > this.maxSize) {
              this.handleOverSize()
              reject(false)
            } else {
              // 设置上传文件为压缩后的文件
              const compressedFile = BlobUtil.Blob([abData], { type: 'image/jpeg' })
              resolve(new File([compressedFile], file.name || '压缩后的文件.jpeg'))
            }
          }
        })
      })
    },

    /**
     * 选中方法
     * @param option 当前选中方法
     */
    handleSelect(option) {
      switch (option.value) {
        case CAMERA:
          // console.log('当前点击了camera')
          bridge.getCamera(99, (file) => {
            // 开始双向绑定
            this.picLink.push(file)
            // 上传文件
            this.handleAfterRead(file)
          })
          break
        case PHOTO:
          bridge.getPhoto((file) => {
            // 开始双向绑定
            this.picLink.push(file)
            // 上传文件
            this.handleAfterRead(file)
          })
          break
        case PDF:
          bridge.getPDF((file) => {
            // 开始双向绑定
            this.picLink.push(file)
            // 上传文件
            this.handleAfterRead(file)
            // this.handleAfterReadPDF(file)
          })
          break
      }
      // 关闭弹框
      this.showUploadSheet = false
    },

    /**
     * 图片超过最大限制
     */
    handleOverSize() {
      if (this.compress) {
        return true
      }
      Toast('选择的图片超过最大限制，请重新选择')
    },

    /**
     * 是否超过尺寸限制
     */
    isOverSize(file) {
      // 如果当前需要压缩，则不判断
      if (this.compress) {
        return false
      }
      return file.size >= this.maxSize
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/BridgeUpload.vue